<template>
	<page id="top" @scrollChange="scrollChange">
		<ZuiHeader />
		<!-- 景点介绍加map -->
		<div class="detailClass" :class="{map:map}" id="scroll-div">
			<div class="banner">
				<PageNavigater></PageNavigater>
				<cms-image v-if="!map"
					:src="pathList=='/link'?linkImg:pathList=='/plan'?planImg:pathList=='/service'?seviceImg:pathList=='/visitor'?visitorImg:defultImg"></cms-image>
				<div class="mapPoint" v-if="map">
					<div class="star" :class="{ac:activeIndex==index}" :style="slide.position" v-for="(slide,index) in swiperSlides" :key="index"
						@click="clickStar(index)">
						<div class="starMask">
							<div class="whiteStar"></div>
							{{ slide.name }}
						</div>
					</div>
				</div>
				<div class="mapTab" v-if="map">
					<swiper class="swiper" ref="mySwiper" :options="swiperOption">
						<swiper-slide class="map-tab-item" :class="{active:activeIndex==index}"
							v-for="(slide,index) in swiperSlides" :key="index">
							{{ slide.name }}
						</swiper-slide>
					</swiper>
					<div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div>
				</div>
			</div>
			<div class="contain">
				<div class="content">
					<div class="bg">
						<div class="title">
                            <div>{{ title }}</div>
							<div class="tuijianstar" v-if="star">
                                <div class="star">
                                    <span>推荐指数：</span>
                                    <el-rate v-model="star" :disabled="true" style="position: relative;top: 2px;"></el-rate>
									<span class="tag" v-if="tag &&  articleData.ext1">{{ articleData.ext1 }}</span>
                                </div>
								<!--适宜人群-->
								<div class="dt_margin" style="margin-left: 100px;" v-if="product && articleData.ext1">
									适宜人群：{{ articleData.ext1 }}</div>
							</div>
							<div class="title-bg"></div>
						</div>
						<!--产品特色-->
						<div class="product" v-if="product">
							{{ articleData.intro }}
						</div>
						<!--温馨提示-->
						<div class="productInfo" v-if="product && articleData.ext2">
							温馨提示：{{ articleData.ext2 }}
						</div>
						<div v-viewer="options" class="richtext" ref="richEl"></div>
						<div class="reviewInformation"> 
							<div v-if="articleData.editor">编辑：{{articleData.editor	}}</div>
							<div v-if="articleData.executiveEditor">责任编辑：{{articleData.executiveEditor	}}</div>
							<div v-if="articleData.auditor">审核：{{articleData.auditor	}}</div>
						</div>
						<!--<div class="article-content" v-if="showSublings">
							<span class="none" v-if="!prevArticle.id">上一篇：暂无</span>
							<a class="article-pre" @click="relatedPNClick(prevArticle.id)"
								v-else>上一篇：{{ prevArticle.title }}</a>
							<span class="none" v-if="!nextArticle.id">下一篇：暂无</span>
							<a class="article-next" @click="relatedPNClick(nextArticle.id)"
								v-else>下一篇：{{ nextArticle.title }}</a>
						</div>-->
					</div>
				</div>
				<div class="about-article" v-if="showRelated">
					<div class="about-article-title">相关文章</div>
					<div class="flex">
						<a class="about-article-item" v-for="item in relatedList" :key="item.id"
							@click="relatedClick(item)">
							<span class="ti">{{ item.title }}</span>
							<span>{{ item.createTime | timeFormat }}</span>
						</a>
						<div class="no-content" v-if="!relatedLoading && relatedList.length === 0">暂无相关文章</div>
					</div>
				</div>
				<!--<div class="detailButton1"  @click="back()">
					<span>返回上级</span>
				</div>-->
				<div class="detailButton2"  @click="toTop()">
					<span>回到顶部</span>
				</div>
			</div>
		</div>
		<ZuiFooter />
	</page>
</template>

<script>
	import {
		getArticle,
		getArticles,
		getNotice,
		getNotices,
		getArticleAdjacent
	} from '~/api/CmsApi'
	import '~/views/less/detail.css'
	import Page from '~/components/Page'
	import ZuiHeader from '~/components/Header'
	import ZuiFooter from '~/components/Footer'
	import {
		swiper,
		swiperSlide
	} from 'vue-awesome-swiper';
	import {
		BZJD
	} from '../../enum/BiaoZhiJingDian';
	import 'swiper/css/swiper.css';
	import Util from '../../Util'

	export default {
		name: 'DetailTemplate',
		components: {
			Page,
			ZuiHeader,
			ZuiFooter,
			swiper,
			swiperSlide
		},
		props: {
			// <!-- 景点介绍加map=true -->
			map: {
				type: Boolean,
				default: false
			},
			tag: { //两日游标签
				type: Boolean,
				default: false
			},
			// 产品特色
			product: {
				type: Boolean,
				default: false
			},
			isNotice: {
				type: Boolean,
				default: false
			},
			activeIndexNum: {
				type: String,
				default: '0'
			},
			/**
			 * 展示相关文章
			 */
			showRelated: {
				type: Boolean,
				default: true
			},
			/**
			 * 展示上一篇、下一篇
			 */
			showSublings: {
				type: Boolean,
				default: true
			},
			// 控制页面顶部的banner图
			bannerType: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				jjImg: require('~/views/img/list/subImg/jdjs-bg.jpg'),
				defultImg: require('~/views/img/list/link-banner.jpg'),
				linkImg: require('~/views/img/list/link-banner.jpg'),
				planImg: require('~/views/img/list/plan-banner.jpg'),
				seviceImg: require('~/views/img/list/sevice-banner.jpg'),
				visitorImg: require('~/views/img/list/visitor-banner.jpg'),
				showButton: false,
				activeIndex: null,
				pathList: [],
				articleData: {},
				star: 0,
				title: '',
				ext1: '',
				articleLoading: false,
				relatedLoading: true,
				relatedList: [],
				prevArticle: {},
				nextArticle: {},
				swiperOption: {
					loop: true,
					slidesPerView: (Util.os().android || Util.os().iPhone) ? 3 : 9,
					centeredSlides: true,
					spaceBetween: 14,
					navigation: {
						nextEl: '.swiper-button-next',
						prevEl: '.swiper-button-prev'
					},
					touchRatio: 0.2,
					slideToClickedSlide: true,
					on: {
						click: () => {
							// 通过$refs获取对应的swiper对象
							let swiper = this.$refs.mySwiper.swiper;
							this.activeIndex = swiper.realIndex
							if (!isNaN(this.activeIndex))
								this.title = this.swiperSlides[this.activeIndex].name;
						},
						slideChange: () => {
							// 通过$refs获取对应的swiper对象
							let swiper = this.$refs.mySwiper.swiper;
							this.activeIndex = swiper.realIndex
							if (!isNaN(this.activeIndex))
								this.title = this.swiperSlides[this.activeIndex].name;

						}
					},
				},
				swiperSlides: BZJD,
				options: {
					inline: false,
					button: true,
					navbar: true,
					title: false,
					toolbar: true,
					tooltip: true,
					movable: true,
					zoomable: true,
					rotatable: true,
					scalable: true,
					transition: true,
					fullscreen: true,
					keyboard: true,
					// url: 'data-source',
				},
				isIE: false,
				isUC: false
			}
		},
		created() {
			if(document.getElementsByClassName('zui-page') && document.getElementsByClassName('zui-page')[0] && document.getElementsByClassName('zui-page')[0].getAttribute("class").includes("mobileClass")){
				this.swiperOption.slidesPerView = 3
			}
			if (document.documentMode)
				this.isIE = true;
			if (navigator.appVersion.indexOf('UBrowser/'))
				this.isUC = true;
			if ((this.isIE || this.isUC) && !document.body.scrollTo) {
				Element.prototype.scrollTo = function(option) {
					this.scrollLeft = option.left;
					this.scrollTop = option.top;
				};
			}
		},
		mounted: function() {
			this.pathList = this.getPathList();
			const id = this.$route.query.id;
			if (id) {
				if (this.isNotice) {
					this.getNotice(id);
				} else {
					this.getArticle(id);
				}
			}
			this.$nextTick(function() {
				if (this.map) {
					this.activeIndex = parseInt(this.activeIndexNum)
					if (isNaN(this.activeIndex))
						this.activeIndex = 0;
					let num = (Util.os().android || Util.os().iPhone) ? 3 : 9;
					this.$refs.mySwiper.swiper.slideTo(this.activeIndex + num, 0, false)
					this.title = this.swiperSlides[this.activeIndex] ? this.swiperSlides[this.activeIndex].name : '';
				}
				window.addEventListener('scroll', this.onScroll);
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			})

			// 监听页面关闭前
			window.addEventListener('beforeunload', () => {
				localStorage.removeItem('article_pid');
				localStorage.removeItem('article_pname');
			});
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.$swiper
			}
		},
		watch: {
			activeIndex: {
				handler(value) {
					if (this.map) {
						const articleId = this.swiperSlides[value] ? this.swiperSlides[value].id : '';
						if (articleId)
							this.getArticle(articleId);
					}
				},
				immediate: true
			}
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.onScroll);
		},
		methods: {
			getPathList() {
				if (this.$route.path === '') {
					return []
				}

				const route = this.$router.getRoutes().find(a => a.path === this.$route.path);
				const pathList = [];
				const putTogether = data => {
					pathList.unshift({
						path: data.path,
						meta: data.meta
					});
					if (data.parent && data.parent.path !== '/home') {
						putTogether(data.parent);
					}
				}
				putTogether(route);
				pathList.unshift({
					path: '/home',
					meta: {
						title: '首页'
					}
				});
				return pathList[1].path;
			},
			getArticle(id) {
				this.articleLoading = true;
				getArticle(id).then(res => {
					if (res.code === 0) {
						this.renderArticle(res.data);
					}
					this.articleLoading = false;
				})
			},
			/**
			 * 渲染文章内容
			 * @param data
			 */
			renderArticle(data) {
				this.title = data.title;
				this.$refs.richEl.innerHTML = data.content;
				this.star = data.star || 0;
				this.articleData = data;

				if (this.showRelated) {
					this.getRelatedArticle(data.cateId, data.createTime);
				}

				// 获取上一篇、下一篇
				if (this.showSublings) {
					this.getPrevNextArticle(data.id, data.cateId, data.createTime);
				}
			},
			getNotice(id) {
				getNotice(id).then(res => {
					if (res.code === 0) {
						this.title = res.data.title;
						this.$refs.richEl.innerHTML = res.data.content;
						this.ext1 = res.data.ext1;

						this.getRelatedNotice();
					}
				})
			},
			getPrevNextArticle(id, cateId, createTime) {
				getArticleAdjacent({
					id,
					cateId,
					createTime
				}).then(res => {
					if (res.code === 0) {
						this.prevArticle = res.data[0] || {
							title: '暂无'
						};
						this.nextArticle = res.data[1] || {
							title: '暂无'
						};
					}
				});
			},
			/**
			 * 获取相关文章
			 */
			getRelatedArticle(cateId) {
				const param = {
					page: 1,
					limit: 8,
					cateId
				};
				this.relatedLoading = true;
				getArticles(param).then(res => {
					if (res.code === 0) {
						const list = res.data.records || [];
						this.relatedList = list.map(item => {
							item.createTime = item.createTime || item.updateTime;
							return item;
						})
					} else {
						this.relatedList = [];
					}
					this.relatedLoading = false;
				})
			},
			getRelatedNotice() {
				const param = {
					page: 1,
					limit: 8,
					displayFilter: '1',
					columnId: '1'
				};
				this.relatedLoading = true;
				getNotices(param).then(res => {
					if (res.code === 0) {
						this.relatedList = res.data.records || [];
					} else {
						this.relatedList = [];
					}
					this.relatedLoading = false;
				})
			},
			onScroll() {
				let scrolled = document.documentElement.scrollTop || document.body.scrollTop // 586、1063分别为第二个和第三个锚点对应的距离
				if (scrolled > 300) {
					this.showButton = true
				} else {
					this.showButton = false
				}
			},
			back() {
				this.$router.go(-1)
			},
			toTop() {
				// document.getElementById('top').scrollIntoView({
				// 	behavior: "smooth"
				// });
				if (this.isIE || this.isUC)
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTop = 0;
				else
					this.$children[0].$refs['scrollview'].$refs['wrap'].scrollTo({ top: 0, behavior: 'smooth' })
			},
			mapTab(e) {
				this.activeIndex = index
			},
			clickStar(index) {
				this.activeIndex = index
				let num = (Util.os().android || Util.os().iPhone) ? 3 : 9;
				this.$refs.mySwiper.swiper.slideTo(index + num, 1000, false)
				this.title = this.swiperSlides[this.activeIndex].name;
			},
			relatedClick(item) {
				const base = this.$router.options.base;
				let route = this.$route.path;
				if (base) {
					route = base + route.substring(1);
				}

				const id = this.isNotice ? item.contentId : item.id;
				window.location.href = `${route}?id=${id}`;
			},
			relatedPNClick(id) {
				if (id) {
					const base = this.$router.options.base;
					let route = this.$route.path;
					if (base) {
						route = base + route.substring(1);
					}
					window.location.href = `${route}?id=${id}`;
				}
			},
			scrollChange(height) {
				if (height > 300) {
					this.showButton = true
				} else {
					this.showButton = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/template/DetailTemplate.vue